import React from 'react';

import { TextField } from '@material-ui/core';
import { useField } from 'formik';
import { at } from 'lodash';

const InputField = (props: any) => {
  const { mailError, errorText, ...rest } = props;
  const [field, meta] = useField(props);

  function renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
    return null;
  }

  return (
    <TextField
      type="text"
      error={(meta.touched && meta.error && true) || mailError === true}
      helperText={renderHelperText()}
      variant="outlined"
      {...field}
      {...rest}
    />
  );
};

export default InputField;
